<div id="table">
  <!-- Primera fila -->
  <div id="first-row">
    <div class="first-column"></div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 1</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 2</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 3</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 4</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 5</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 6</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 7</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 8</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 9</span>
    </div>
    <div class="column">
      <span class="nomenclature caption-01-bold value-content">Grupo 10</span>
    </div>
  </div>

  <div id="columns">
    <!-- Primera columna -->
    <div id="first-column">
      <div class="row">
        <span class="nomenclature caption-01-bold">Promedio Com.</span>
      </div>
      <div class="row">
        <span class="nomenclature caption-01-bold">Promedio P.I</span>
      </div>
      <div class="row">
        <span class="nomenclature caption-01-bold">Promedio E.P</span>
      </div>
      <div class="row">
        <span class="nomenclature caption-01-bold">Compartidas</span>
      </div>
      <div class="row">
        <span class="nomenclature caption-01-bold">Rotación cartera</span>
      </div>
      <div class="row">
        <span class="nomenclature caption-01-bold">Transacción</span>
      </div>
    </div>
    <!-- Columnas -->
    <ng-container
      *ngIf="!isLoading && averages.length !== 0; else noData"
    >
      <div class="column" *ngFor="let average of averages">
        <div class="row">
          <!-- Promedio Com. -->
          <span class="text paragraph-02-regular value-content">{{
            this.utilsService.formatNumberWithDot(average.comisiones.toFixed())
          }}</span>
        </div>
        <div class="row even">
          <!-- Promedio P.I -->
          <span class="text paragraph-02-regular value-content">{{
            this.utilsService.formatNumberWithDot(average.prodIndividual.toFixed())
          }}</span>
        </div>
        <div class="row">
          <!-- Promedio E.P -->
          <span class="text paragraph-02-regular value-content">{{
            this.utilsService.formatDecimalWithComma(average.equipoProductivo.toFixed(2))
          }}</span>
        </div>
        <!-- Compartidas -->
        <div class="row even">
          <span class="text paragraph-02-regular value-content"
            >{{ this.utilsService.formatDecimalWithComma(average.compartidas.toFixed(2)) }}%</span
          >
        </div>
        <div class="row">
          <!-- Rotación cartera -->
          <span class="text paragraph-02-regular value-content"
            >{{ this.utilsService.formatDecimalWithComma(average.rotacion.toFixed(2)) }}%</span
          >
        </div>
        <div class="row even">
          <!-- Transacción -->
          <span class="text paragraph-02-regular value-content"
            >{{ this.utilsService.formatDecimalWithComma(average.transacciones.toFixed(2)) }}%</span
          >
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #noData>
  <div id="no-data">
    <h1 id="title-no-data" class="heading-02-semi-bold">
      En este momento no hay promedios disponibles
    </h1>
  </div>
</ng-template>

<!-- Referencias de grupos -->
<div id="groups">
  <div class="group" *ngFor="let group of groups">
    <h3 class="title caption-01-bold">Grupo {{ group.id }}</h3>
    <p class="location subheading-01-semi-bold">{{ group.location }}</p>
    <p class="antiquity subheading-01-semi-bold">{{ group.antiquity }}</p>
  </div>
</div>
